module.exports = __webpack_public_path__ + "static/media/nHysOTkN8e.4e115be4.jpg";